import { Form, Radio, Table, Button, Select, message, Space } from '@drip/drip-design';
import React, { useState } from 'react';
import ValidateErp from '@/components/validate-erp';
import Delete from '@/components/delete';
import SelectHrDepart from 'src/components/select-hr-depart/index.js';
import { addMemberList } from '@/components/SpacialListConfig/apis';
import { PlusCircleOutlined } from '@drip/drip-design-icons';

const initValue = {
  allocationType: '1',
  1: {
    tabForm: [
      {
        erps: '',
        identityType: '3',
      },
    ],
  },
  2: {
    tabForm: [
      {
        identityType: '4',
        organization: [],
      },
    ],
  },
  3: {
    tabForm: [
      {
        identityType: '4',
      },
    ],
  },
};

export default function DistributeForm({ onCancel, id, isPartner }) {
  const [form] = Form.useForm();
  const options = [
    { label: '分配erp', value: '1' },
    { label: '分配部门', value: '2' },
    { label: '分配全部erp', value: '3', hidden: isPartner },
  ].filter((ele) => !ele.hidden);

  const submitForm = (val) => {
    const { allocationType } = val;
    let tabForm = val[allocationType].tabForm;
    tabForm = tabForm.map((item) => {
      let { erps = '', identityType, organization = [] } = item;
      if (allocationType == '1') {
        return {
          identityType,
          erps: erps.split(','),
        };
      }
      if (allocationType == '2') {
        organization = JSON.parse(organization[organization.length - 1] || '');
        return {
          identityType,
          organizationName: organization.name,
          organization: organization.id,
        };
      }
      return {
        identityType,
      };
    });
    addMemberList({ whiteId: id, allocationType, datas: tabForm })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '权限分配失败';
        message.success('权限分配成功');
        form.setFieldsValue(initValue);
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  return (
    <Form form={form} initialValues={initValue} onFinish={submitForm} className="distribute-form">
      <Form.Item name="allocationType" noStyle>
        <Radio.Group optionType="button" options={options} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.allocationType !== curr.allocationType}>
        {({ getFieldValue }) => {
          const allocationType = getFieldValue('allocationType');
          return (
            <Form.List name={[allocationType, 'tabForm']}>
              {(fields, { remove, add }) => {
                return <InnerTable allocationType={allocationType} add={add} remove={remove} fields={fields} />;
              }}
            </Form.List>
          );
        }}
      </Form.Item>

      <Space className="distribute-form-submit">
        <Button onClick={onCancel}>取消</Button>
        <Button type="primary" htmlType="submit">
          确认分配
        </Button>
      </Space>
    </Form>
  );
}

function InnerTable(props) {
  const { allocationType, add, remove, fields } = props;

  const options = [
    { label: '协作者', value: '3', hidden: ['2', '3'].includes(allocationType) },
    { label: '申请者', value: '4' },
  ].filter((ele) => !ele.hidden);

  const columns = [
    {
      title: '分配对象',
      width: '500px',
      render(a, b, rowKey) {
        if (allocationType === '1') {
          return (
            <ValidateErp
              style={{ width: '100%', minWidth: 400 }}
              name={[fields[rowKey].name, 'erps']}
              label={null}
              validateTrigger="onBlur"
              type="default"
            />
          );
        }
        if (allocationType === '2') {
          return (
            <Form.Item name={[fields[rowKey].name, 'organization']} rules={[{ required: true, message: '请选择部门' }]}>
              <SelectHrDepart maxTagCount="responsive" style={{ width: 468 }} />
            </Form.Item>
          );
        }
        return <div style={{ height: 50, lineHeight: '50px' }}>分配全部erp</div>;
      },
    },
    {
      title: '权限类型',
      render(a, b, rowKey) {
        return (
          <Form.Item noStyle name={[fields[rowKey].name, 'identityType']} initialValue={'4'}>
            <Select style={{ width: 75 }} bordered={false} options={options} className="auth-select" />
          </Form.Item>
        );
      },
    },
    {
      title: '操作',
      render(a, b, rowKey) {
        return rowKey ? (
          <Delete onConfirm={() => remove(rowKey)}>
            <a>删除</a>
          </Delete>
        ) : null;
      },
    },
  ];

  return (
    <>
      <Table dataSource={fields} columns={columns} pagination={false} bordered />
      {allocationType == '3' ? null : (
        <div className="form-add-btn">
          <span onClick={add} style={{ cursor: 'pointer' }}>
            <PlusCircleOutlined />
            新增分配对象
          </span>
        </div>
      )}
    </>
  );
}
